import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast, Toaster } from "sonner";
import { IMAGES } from "../../data/content";
import { crmReset, formatApiError } from "../../lib/crm";

export default function CrmReset() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("A senha deve ter pelo menos 8 caracteres");
      return;
    }
    if (password !== confirm) {
      toast.error("As senhas não coincidem");
      return;
    }
    setLoading(true);
    try {
      await crmReset(token, password);
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Não foi possível redefinir."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain-overlay flex min-h-screen items-center justify-center bg-[#141210] px-5">
      <Toaster position="top-center" richColors />
      <div className="relative z-10 w-full max-w-sm rounded-3xl border border-gold/20 bg-white/5 p-8 backdrop-blur-sm sm:p-10">
        <img src={IMAGES.logo} alt="Logo Ministério AURA" className="mx-auto h-14 w-14 rounded-full object-cover" />
        {done ? (
          <div className="mt-8 text-center" data-testid="crm-reset-success">
            <CheckCircle2 className="mx-auto h-10 w-10 text-teal" />
            <h1 className="mt-4 font-serif text-2xl text-white">Senha redefinida</h1>
            <button
              data-testid="crm-reset-goto-login"
              onClick={() => navigate("/crm/login")}
              className="mt-6 w-full rounded-full bg-gold py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors hover:bg-champagne"
            >
              Ir para o login
            </button>
          </div>
        ) : (
          <>
            <h1 className="mt-6 text-center font-serif text-2xl text-white">Nova senha</h1>
            <form onSubmit={handleSubmit} className="mt-8 space-y-4" data-testid="crm-reset-form">
              <input
                data-testid="crm-reset-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white outline-none transition-colors focus:border-gold/60"
                placeholder="Nova senha (mín. 8 caracteres)"
              />
              <input
                data-testid="crm-reset-confirm"
                type="password"
                required
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white outline-none transition-colors focus:border-gold/60"
                placeholder="Confirmar nova senha"
              />
              <button
                data-testid="crm-reset-submit"
                type="submit"
                disabled={loading || !token}
                className="w-full rounded-full bg-gold py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors hover:bg-champagne disabled:opacity-60"
              >
                {loading ? <Loader2 className="mx-auto h-4 w-4 animate-spin" /> : "Redefinir senha"}
              </button>
            </form>
          </>
        )}
        <Link to="/crm/login" className="mt-6 block text-center text-[10px] uppercase tracking-[0.2em] text-white/40 transition-colors hover:text-champagne">
          Voltar ao login
        </Link>
      </div>
    </div>
  );
}
